module.exports = __webpack_public_path__ + "static/media/distribute_bg.cd940eae.png";